import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'

AxiosInterceptor()

const productLeaseService = {
  async index(pageNumber: number, sortOrder: string, status: string) {
    return axios.get(
      `/product-leases?pageNumber=${pageNumber}&sortOrder=${sortOrder}&status=${status}`,
    )
  },

  async single(id: string | undefined) {
    return axios.get(`/product-leases/${id}`)
  },

  async pay(id: string | undefined, data: { amountMajor: number }) {
    return axios.post(`/product-leases/${id}/pay`, data)
  },
}
export default productLeaseService
